import { getIn18Text, api, apis, getDingTalkSearchString, getFeiShuUrl, addDingTalkSearchStringToUrl, } from 'api';
import message from '@web-common/components/UI/Message/SiriusMessage';
import SiriusModal from '@web-common/components/UI/Modal/SiriusModal';
import { ATTACHMENT_KEYS } from '@web-mail/common/components/vlistCards/MailCard/DefaultAttachment';
import cloneDeep from 'lodash/cloneDeep';
import { IMG_TYPES } from '@web-mail/common/constant';
import { getFileExt } from '@web-common/utils/file';
import ImgPreview from '@web-common/components/UI/ImagePreview';
import { isMainAccount } from '@web-mail/util';
const trackApi = api.requireLogicalApi(apis.dataTrackerApiImp);
const diskApi = api.requireLogicalApi(apis.netStorageImpl);
const accountApi = api.requireLogicalApi(apis.accountApiImpl);
const mailConfApi = api.requireLogicalApi(apis.mailConfApiImpl);
const httpApi = api.getDataTransApi();
const systemApi = api.getSystemApi();
export const normalizeShareUrl = (url) => (url.indexOf('http') === 0 ? url : `https://${url}`);
export const isImage = (fileName, _fileType) => {
    const fileType = _fileType || getFileExt(fileName);
    return IMG_TYPES.includes(fileType);
};
export const openImgAttachment = (item) => {
    const onList = [];
    onList.push(Object.assign(Object.assign({}, item), { nonOriginal: item.nonOriginal === undefined ? true : item.nonOriginal }));
    ImgPreview.preview({ data: onList, startIndex: 0 });
};
export const openDiskFile = (item) => {
    trackApi.track('pcMail_view_mailAttachmentsSpace', { spaceTab: getIn18Text('YOUJIANYUNFUJIAN') });
    const { fileName } = item;
    if (DeleteFileToast(item.expireTime))
        return;
    diskApi
        .previewCloudAtt({ identity: item.identity })
        .then(data => {
        if (data) {
            const shareUrl = normalizeShareUrl(data);
            if (systemApi.isElectron()) {
                const ts = Date.now();
                const downloadUrl = item.downloadUrl;
                systemApi.createWindowWithInitData('resources', {
                    eventName: 'initPage',
                    eventData: {
                        hash: `${location.href}/resources/#identity=${item.identity}&type=attachment`,
                        type: 'attachment',
                        downloadContentId: ts,
                        downloadId: 0,
                        fileName: item.fileName,
                        attachments: [
                            {
                                from: 'cloudAttCont',
                                filePreviewUrl: shareUrl,
                                fileUrl: downloadUrl,
                                id: item.identity,
                                name: fileName,
                                fileName,
                                fileSize: item.fileSize,
                                fileSourceType: 3,
                                type: 'url',
                                cloudAttachment: true,
                                fileSourceKey: item.identity,
                                downloadContentId: ts,
                                downloadId: 0,
                            },
                        ],
                    },
                });
            }
            else {
                systemApi.openNewWindow(shareUrl);
            }
        }
    })
        .catch(error => {
        var _a;
        message.error({ content: ((_a = error === null || error === void 0 ? void 0 : error.data) === null || _a === void 0 ? void 0 : _a.message) || getIn18Text('HUOQUYULANDE') });
    });
};
export const openShareUrl = (shareUrl) => {
    if (systemApi.isElectron()) {
        systemApi.handleJumpUrl(-1, shareUrl);
    }
    else {
        systemApi.openNewWindow(shareUrl);
    }
};
const DeleteFileToast = (expireTime) => {
    if (expireTime != null && expireTime !== 0 && expireTime < Date.now()) {
        SiriusModal.error({
            title: getIn18Text('WENJIANBUCUNZAI'),
            content: null,
        });
        return true;
    }
    return false;
};
export const openWebPreview = (_downloadInfo, _composeId, _account) => {
    const downloadInfo = cloneDeep(_downloadInfo);
    if (_account) {
        downloadInfo._account = _account;
        updateFileAttachment(downloadInfo, _account);
    }
    const searchStrArr = [];
    const composeId = _composeId || _downloadInfo.contentId;
    if (composeId) {
        downloadInfo.downloadContentId = composeId;
        searchStrArr.push('attType=1');
    }
    ATTACHMENT_KEYS.forEach(k => {
        const value = ((downloadInfo && downloadInfo[k]) || '');
        if (value) {
            searchStrArr.push(`${k}=${encodeURIComponent(value)}`);
        }
    });
    let searchStr = searchStrArr.join('&');
    const url = `${systemApi.getContextPath()}/attachment/?${getDingTalkSearchString(false, true)}outDownloadContentId=${encodeURIComponent(downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.downloadContentId)}&${searchStr}`;
    window.open(`${getFeiShuUrl(url)}`);
};
export const openWebAttach = (downloadContentId, filePreviewUrl, fileName) => {
    window.open(`${systemApi.getContextPath()}/attachment/?downloadContentId=${encodeURIComponent(downloadContentId)}&filePreviewUrl=${encodeURIComponent(filePreviewUrl)}&fileName=${encodeURIComponent(fileName)}`);
};
const getNewUrlWithNewToken = (account, url) => {
    try {
        if (account && url) {
            let resUrl = url;
            const hasToken = url.indexOf('_token') > -1;
            if (hasToken) {
                const newToken = mailConfApi.getTokenBySubAccount(account);
                resUrl = newToken ? url.replace(/(\?|&|%3F|%26)_token(=|%3D)[0-9a-zA-Z*\-_.]+/gi, '$1_token$2' + newToken) : url;
            }
            const hasSid = url.indexOf('sid') > -1;
            if (hasSid) {
                const accountUser = systemApi.getCurrentUser(account);
                if (accountUser) {
                    const newSid = accountUser.sessionId ? accountUser.sessionId : '';
                    if (newSid) {
                        resUrl = url.replace(/(\?|&|%3F|%26)sid(=|%3D)[0-9a-zA-Z*\-_.]+/gi, '$1sid$2' + newSid);
                    }
                }
            }
            return resUrl;
        }
        return url;
    }
    catch (ex) {
        console.error(`getNewUrlWithNewToken error`, ex);
        return url;
    }
};
const updateFileAttachment = (fileAttach, account) => {
    if (fileAttach) {
        if (fileAttach.filePreviewUrl) {
            fileAttach.filePreviewUrl = getNewUrlWithNewToken(account, fileAttach.filePreviewUrl || '');
        }
        if (fileAttach.fileUrl) {
            fileAttach.fileUrl = getNewUrlWithNewToken(account, fileAttach.fileUrl || '');
        }
    }
};
export const reportAttachPreview = (params) => {
    mailConfApi.reportAttachPreview(params);
};
export const buildPreviewUrl = (item, _account) => {
    const user = systemApi.getCurrentUser(_account);
    if (!user) {
        console.error('buildPreviewUrl error 必须登录');
        return '';
    }
    const subAccount = accountApi.getEmailIdByEmail(_account || user.id);
    const isCorpMail = systemApi.getIsCorpMailMode();
    const host = isCorpMail ? user.domain : mailConfApi.getWebMailHost(true, subAccount).replace(/^.*?:\/\//, '');
    const req = {
        product: 'MAIL',
        fullFileName: item.fileName,
        sid: user.sessionId,
        uid: user.id,
        mid: item.contentId || item.downloadContentId,
        attType: item.contentId ? '1' : '0',
        part: item.id + '',
        host,
        _session: '',
    };
    return httpApi.buildUrl(systemApi.getUrl('filePreview'), req);
};
export const getAttachControlState = async (account, options) => {
    var _a;
    const accountId = accountApi.getEmailIdByEmail(account || ((_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '');
    const mainAccount = isMainAccount(accountId);
    if ((options === null || options === void 0 ? void 0 : options.isTpMail) === true) {
        return { isMainAccount: mainAccount, previewEnabled: false, downloadBanned: false };
    }
    if (!mainAccount) {
        return { isMainAccount: false, previewEnabled: false, downloadBanned: false };
    }
    const ban = await mailConfApi.getAccountBanSetting(account);
    const previewEnabled = ban.ban_legacy_attach_preview === true;
    const downloadBanned = previewEnabled && ban.ban_download_attach_pc === true;
    return { isMainAccount: true, previewEnabled, downloadBanned };
};
export const buildAttachPreviewContainerUrl = (params) => {
    const { mailId, partId, account } = params;
    const user = systemApi.getCurrentUser(account);
    if (!user) {
        console.error('buildAttachPreviewContainerUrl error 必须登录');
        return '';
    }
    const query = [`id=${encodeURIComponent(mailId)}`, `uid=${encodeURIComponent(user.id)}`, `sid=${encodeURIComponent(user.sessionId || '')}`, 'env=pc'];
    if (partId != null && partId !== '') {
        query.push(`partid=${encodeURIComponent(String(partId))}`);
    }
    return `${window.location.origin}/static/qiye-file-preview/index.html?${query.join('&')}`;
};
export const openAttachPreviewContainer = (url) => {
    if (!url)
        return;
    if (systemApi.isElectron() && window.electronLib) {
        systemApi.createWindow({
            type: 'customer',
            url,
            setMainWindowCookie: true,
            setMainLocalStorage: true,
            specifyCookieDomain: '.qiye.163.com',
        });
        return;
    }
    window.open(getFeiShuUrl(addDingTalkSearchStringToUrl(url)));
};
